// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jUWTE{position:relative;display:flex;overflow:auto}.jUWTE.Z4hIU{flex-direction:column;overflow-x:hidden;overflow-y:auto}.jUWTE.Z4hIU>*{min-height:var(--item-min-size);max-height:var(--item-max-size);height:var(--item-size, auto);flex-shrink:0;flex-grow:0}.jUWTE.pZXIg{flex-direction:row;overflow-x:auto;overflow-y:hidden}.jUWTE.pZXIg>*{min-width:var(--item-min-size);max-width:var(--item-max-size);width:var(--item-size, auto);flex-shrink:0;flex-grow:0}.jUWTE.Aag0W{scrollbar-width:none;-ms-overflow-style:none}.jUWTE.Aag0W::-webkit-scrollbar{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `jUWTE`,
	"vertical": `Z4hIU`,
	"horizontal": `pZXIg`,
	"hideScrollbar": `Aag0W`
};
export default ___CSS_LOADER_EXPORT___;
